import {PieChartWithLabelsRow} from "../../../../../../dashboard/widgets/charts/PieChartWithLabels";
import {LegendItem} from "../../../../../../components/charts/Legend";
import {CoffeeConsumptionByType} from "../../../data/CoffeeMachineJsonMapper";

export function processConsumptionData(
    data: CoffeeConsumptionByType[],
    thresholds: number[],
    legendItems: LegendItem[],
    consumptionFilter: boolean,
): PieChartWithLabelsRow[] {
    const frequencies: number[] = new Array<number>(thresholds.length - 1);
    frequencies.fill(0);

    data.forEach((consumption) => {
        if (consumptionFilter !== null && consumption.continueConsumption !== consumptionFilter) {
            return;
        }
        for (let i = 0; i < consumption.distribution.length; i++) {
            frequencies[i] += consumption.distribution[i].count;
        }
    });

    return frequencies.map<PieChartWithLabelsRow>((frequency, idx) => {
        return {
            code: legendItems[idx].code,
            label: legendItems[idx].name,
            frequency:  frequencies[idx],
            color: legendItems[idx].color,
        };
    });
}
